"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Icons_1 = __importDefault(require("./Icons"));
var Agreement = /** @class */ (function (_super) {
    __extends(Agreement, _super);
    function Agreement() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Agreement.prototype.render = function () {
        var _a = this.props, amount = _a.amount, isVisible = _a.isVisible;
        if (!isVisible) {
            return null;
        }
        return (React.createElement("div", { className: "d-lg-flex align-items-cente" },
            React.createElement("div", { className: "tradein-estimate__disclaimer", style: { display: amount === 0 ? 'none' : '' } },
                React.createElement("sup", null, "*"),
                " \u0423\u043A\u0430\u0437\u0430\u043D\u043D\u0430\u044F \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u044C \u044F\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0439, \u0442\u043E\u0447\u043D\u0443\u044E \u043E\u0446\u0435\u043D\u043A\u0443 \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u0438 \u0412\u0430\u0448\u0435\u0433\u043E \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u044F \u0443\u0442\u043E\u0447\u043D\u044F\u0439\u0442\u0435 \u0432 \u043E\u0444\u0438\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u043C \u0434\u0438\u043B\u0435\u0440\u0441\u043A\u043E\u043C \u0446\u0435\u043D\u0442\u0440\u0435 Suzuki"),
            React.createElement("div", { className: "tradein-estimate__logo" },
                React.createElement(Icons_1.default.AutoRuLogo, null))));
    };
    return Agreement;
}(React.PureComponent));
exports.default = Agreement;
